import { Button } from "../../../utils/Button";
import { GameVars } from "../../../GameVars";
import { GameConstants } from "../../../GameConstants";
import { GameManager } from "../../../GameManager";
import { StrikerSlider } from "./StrikerSlider";
import { StrikerSpeedSetter } from "./StrikerSpeedSetter";
import { BoardContainer } from "../BoardContainer";
import { BoardScene } from "../BoardScene";
import { ColyseusManager } from "../../../ColyseusManager";
import { TutorialScene } from "../../instructions-scene/TutorialScene";
import { TutorialCursor } from "../../instructions-scene/TutorialCursor";
import { AudioManager } from "../../../AudioManager";

import * as Carrom from "carrom-king-engine";
import { BootScene } from "../../BootScene";

export class GUI extends Phaser.GameObjects.Container {

    public strikerSlider: StrikerSlider;
    public playerStrikerSpeedSetter: StrikerSpeedSetter;
    public adversaryStrikerSpeedSetter: StrikerSpeedSetter;
    public tutorialCursor: TutorialCursor;

    private f: number;
    
    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.f = 0;

        this.strikerSlider = new StrikerSlider(this.scene, this);
        this.add(this.strikerSlider);

        this.strikerSlider.activate();

        this.playerStrikerSpeedSetter = new StrikerSpeedSetter(this.scene, true, this);
        this.playerStrikerSpeedSetter.deactivate();
        
        BoardContainer.currentInstance.strikerControlsContainer.add(this.playerStrikerSpeedSetter.circleGraphics);
        BoardContainer.currentInstance.strikerControlsDotsContainer.add(this.playerStrikerSpeedSetter.dotsGraphics);
        BoardContainer.currentInstance.strikerControlsDotsContainer.add(this.playerStrikerSpeedSetter.arrow);

        this.adversaryStrikerSpeedSetter = new StrikerSpeedSetter(this.scene, false, this);

        BoardContainer.currentInstance.strikerControlsContainer.add(this.adversaryStrikerSpeedSetter.circleGraphics);
        BoardContainer.currentInstance.strikerControlsDotsContainer.add(this.adversaryStrikerSpeedSetter.dotsGraphics);
        BoardContainer.currentInstance.strikerControlsDotsContainer.add(this.adversaryStrikerSpeedSetter.arrow);

        if (!GameVars.tutorialMode) {
 
            const chatButton = new Button(this.scene, 60, GameConstants.GAME_HEIGHT - 60 * GameVars.scaleY, "texture_atlas_1", "btn_chat_off", "btn_chat_on");
            chatButton.onDown(this.onClickChat, this);
            chatButton.scaleY = GameVars.scaleY;
            this.add(chatButton);
    
            const menuButton = new Button(this.scene, GameConstants.GAME_WIDTH - 60, GameConstants.GAME_HEIGHT - 60 * GameVars.scaleY, "texture_atlas_1", "btn_menu_off", "btn_menu_on");
            menuButton.onDown(this.onClickMenu, this);
            menuButton.scaleY = GameVars.scaleY;
            this.add(menuButton);

            if (GameConstants.DEVELOPMENT) {

                const devLabel = new Phaser.GameObjects.Text(this.scene, 180, GameConstants.GAME_HEIGHT - 60 * GameVars.scaleY, "ONLINE", {fontFamily: "Arial", fontStyle: "bold", fontSize: "15px", color: "#000000"});
                devLabel.setOrigin(.5,BootScene.originY);
                devLabel.scaleY = GameVars.scaleY;

                const connectionButton = new Button(this.scene, 180, GameConstants.GAME_HEIGHT - 60 * GameVars.scaleY, "texture_atlas_1", "btn_force_win_off", "btn_force_win_on");
                connectionButton.onDown(() => {this.onClickConnection(connectionButton, devLabel); }, this);
                connectionButton.setScale(2, 2 * GameVars.scaleY);
                this.add(connectionButton);

                this.add(devLabel);
            }
        }

        if (GameConstants.DEVELOPMENT) {

            const width = 225;

            const devMenuCapsule = new Phaser.GameObjects.Graphics(this.scene);
            devMenuCapsule.x = GameConstants.GAME_WIDTH / 2 - width / 2;
            devMenuCapsule.y = GameConstants.GAME_HEIGHT - 112 * GameVars.scaleY;
            devMenuCapsule.fillStyle(0xFFFFFF, .5);
            devMenuCapsule.fillRoundedRect(0, 0, width, 105, 10);
            this.add(devMenuCapsule);

            const logButton = new Button(this.scene, GameConstants.GAME_WIDTH / 2 - 35, GameConstants.GAME_HEIGHT - 70 * GameVars.scaleY, "texture_atlas_1", "btn_menu_off", "btn_menu_on");
            logButton.onDown(this.onClickLogLastShot, this);
            logButton.setScale(.65, .65 * GameVars.scaleY);
            this.add(logButton);
    
            const resetButton = new Button(this.scene, GameConstants.GAME_WIDTH / 2 + 35, GameConstants.GAME_HEIGHT - 70 * GameVars.scaleY, "texture_atlas_1", "btn_reset_off", "btn_reset_on");
            resetButton.onDown(this.onClickReset, this);
            resetButton.setScale(.65, .65 * GameVars.scaleY);
            this.add(resetButton);

            const forceWinButton = new Button(this.scene, GameConstants.GAME_WIDTH / 2 + 90, GameConstants.GAME_HEIGHT - 85 * GameVars.scaleY, "texture_atlas_1", "btn_force_win_off", "btn_force_win_on");
            forceWinButton.onDown(this.onClickForceWin, this);
            forceWinButton.setScale(.65, .65 * GameVars.scaleY);
            this.add(forceWinButton);

            const forceLoseButton = new Button(this.scene, GameConstants.GAME_WIDTH / 2 + 90, GameConstants.GAME_HEIGHT - 55 * GameVars.scaleY, "texture_atlas_1", "btn_force_lose_off", "btn_force_lose_on");
            forceLoseButton.onDown(this.onClickForceLose, this);
            forceLoseButton.setScale(.65, .65 * GameVars.scaleY);
            this.add(forceLoseButton);

            let devLabelStr = GameVars.playingAgainstBot ? GameVars.gameMode + "-bot" : GameVars.gameMode;

            const devLabel = new Phaser.GameObjects.Text(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT - 24 * GameVars.scaleY, devLabelStr, {fontFamily: "Arial", fontSize: "22px", color: "#FFFFFF"});
            devLabel.setOrigin(.5);
            devLabel.scaleY = GameVars.scaleY;
            this.add(devLabel);
        }
        
        this.scene.input.addListener("pointerdown", this.onDown, this);
        this.scene.input.addListener("pointerup", this.onUp, this);
    }

    public update(): void {

        if (GameVars.currentTurnPlayerId === GameVars.playerData.id) {

            this.strikerSlider.update();
            this.playerStrikerSpeedSetter.update();

            this.f ++;

            if (this.f === 30) {
                this.f = 0;
                if (BoardContainer.currentInstance.striker.canBePositionedWithCursor && !GameVars.tutorialMode && GameVars.connection) {
                    ColyseusManager.sendMessage("STREAKER POS SPEED DIRECTION", {px: BoardContainer.currentInstance.strikerPosition.x, r: this.playerStrikerSpeedSetter.r, a: this.playerStrikerSpeedSetter.angle});
                }
            }

        } else {
            this.adversaryStrikerSpeedSetter.update();
        }
    }

    public onShot(): void {

        this.strikerSlider.deactivate();
        this.adversaryStrikerSpeedSetter.deactivate();
    }

    public onNewTurn(): void {

        if (GameVars.currentTurnPlayerId === GameVars.playerData.id) {
            
            this.strikerSlider.activate();
            this.adversaryStrikerSpeedSetter.deactivate();

            if (!this.scene.game.device.os.desktop) {
                try {
                    window.navigator.vibrate(200);
                } catch (e) {
                    // console.log(e);
                }
            }
           
        } else {
            this.strikerSlider.deactivate();
            this.playerStrikerSpeedSetter.deactivate();
            this.adversaryStrikerSpeedSetter.activate();
        }
    }

    public deactivateAll(): void {
        this.strikerSlider.deactivate();
        this.playerStrikerSpeedSetter.deactivate();
        this.adversaryStrikerSpeedSetter.activate();
    }

    public onGameOver(): void {

        this.playerStrikerSpeedSetter.deactivate();
        this.adversaryStrikerSpeedSetter.deactivate();

        this.scene.add.tween({
            targets: this,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350
        });
    }

    public onTutorialStart(): void {

        this.tutorialCursor = new TutorialCursor(this.scene);
        this.tutorialCursor.visible = false;
        this.scene.add.existing(this.tutorialCursor);
    }

    public onTutorialStage0(): void {

        this.visible = false;
    }

    public onTutorialStage1(): void {

        this.visible = true;
        this.tutorialCursor.visible = true;
    }

    public onTutorialStage2(): void {

        this.tutorialCursor.onTutorialStage2();
        this.strikerSlider.tutorialCursor.destroy();
    }

    public onTutorialStage3(): void {

        this.strikerSlider.deactivate();
        this.strikerSlider.visible = false;
        this.playerStrikerSpeedSetter.activate();
        this.tutorialCursor.onTutorialStage3();
    }

    public onTutorialStage4(): void {

        this.tutorialCursor.destroy();
    }

    private onDown(p: any): void {

        if (GameVars.paused || !GameVars.turnCompleted || GameVars.currentTurnPlayerId !== GameVars.playerData.id || GameVars.waintingTurn) {
            return;
        }

        if (GameVars.tutorialMode && GameVars.tutorialStage === TutorialStage.STAGE_3) {
            TutorialScene.currentInstance.tutorialManager.onStrikerDown();
        }

        if (GameVars.tutorialMode && GameVars.tutorialStage !== TutorialStage.STAGE_4) {
            return;
        }

        // check if the active pointer is over the striker
        const strikerPosition = BoardContainer.currentInstance.strikerPosition;

        if (GameVars.reversedBoard) {
            strikerPosition.x = -strikerPosition.x;
            strikerPosition.y = -strikerPosition.y;
        }

        strikerPosition.x = strikerPosition.x * GameConstants.PHYS_SCALE * BoardContainer.currentInstance.scaleX + GameConstants.GAME_WIDTH / 2;
        strikerPosition.y = strikerPosition.y * GameConstants.PHYS_SCALE * BoardContainer.currentInstance.scaleY + GameConstants.GAME_HEIGHT / 2;

        const r = Phaser.Math.Distance.Between(p.downX, p.downY, strikerPosition.x, strikerPosition.y);

        const strikerRadius = GameVars.carromEngine.strikerRadius;

        if (r < strikerRadius * GameConstants.PHYS_SCALE * .95) {
            this.playerStrikerSpeedSetter.activate();
        } else {
            this.playerStrikerSpeedSetter.deactivate();
        }
    }

    private onUp(): void {

        if (GameVars.paused || !GameVars.turnCompleted || GameVars.waintingTurn || GameVars.currentTurnPlayerId !== GameVars.playerData.id || (!GameVars.connection && !GameVars.tutorialMode)) {
            return;
        }

        if (this.playerStrikerSpeedSetter.activated) {
            
            const angle = this.playerStrikerSpeedSetter.angle;
            const r = this.playerStrikerSpeedSetter.r;
            const strikerRadius = GameVars.carromEngine.strikerRadius;

            if (r > strikerRadius * GameConstants.PHYS_SCALE * .95)  {

                let vx = r / StrikerSpeedSetter.MAX_RADIUS * GameConstants.MAX_STRIKER_SPEED * Math.cos(angle);
                let vy = r / StrikerSpeedSetter.MAX_RADIUS * GameConstants.MAX_STRIKER_SPEED * Math.sin(angle);

                if (GameVars.reversedBoard) {
                    vx = -vx;
                    vy = -vy;
                }

                vx = Carrom.Maths.fixNumber(vx);
                vy = Carrom.Maths.fixNumber(vy);

                let strikerPosition: Carrom.Vector2D;
                let strikerVelocity: Carrom.Vector2D;

                if (GameVars.tutorialMode) {

                    strikerPosition = new Carrom.Vector2D(GameConstants.STRIKER_TUTORIAL_PX, GameVars.carromEngine.strikerY);
                    strikerVelocity = new Carrom.Vector2D(1750 * Math.cos(GameConstants.STRIKER_TUTORIAL_SHOT_ANGLE), 1750 * Math.sin(GameConstants.STRIKER_TUTORIAL_SHOT_ANGLE));
                    TutorialScene.currentInstance.tutorialManager.shoot(strikerPosition, strikerVelocity);

                } else {
                    strikerPosition = new Carrom.Vector2D(BoardContainer.currentInstance.strikerPosition.x, BoardContainer.currentInstance.strikerPosition.y);
                    strikerVelocity = new Carrom.Vector2D(vx, vy);
                    BoardScene.currentInstance.boardManager.shoot(strikerPosition, strikerVelocity);
                }
            } 
        }
       
        if (GameVars.tutorialMode && GameVars.tutorialStage === TutorialStage.STAGE_3) {
            this.playerStrikerSpeedSetter.activate();
        } else {
            this.playerStrikerSpeedSetter.deactivate();
        }
    }

    private onClickConnection(button: Button, text: Phaser.GameObjects.Text): void {

        AudioManager.playSound("click_btn");

        GameVars.connection = !GameVars.connection;

        if (GameVars.connection) {
            button.setFrames("btn_force_win_off", "btn_force_win_on");
            text.text = "ONLINE";
        } else {
            button.setFrames("btn_force_lose_off", "btn_force_lose_on");
            text.text = "OFFLINE";
            ColyseusManager.simulateDisconnection();
        }
    }

    private onClickChat(): void {

        if (GameVars.paused || BoardScene.currentInstance.emojisLayer !== null) {
            return;
        }

        AudioManager.playSound("click_btn");

        const boardManager = BoardScene.currentInstance.boardManager;
        boardManager.showEmojisMenu();
    }

    private onClickMenu(): void {

        if (GameVars.paused) {
            return;
        }

        AudioManager.playSound("click_btn");
        
        const boardManager = BoardScene.currentInstance.boardManager;
        boardManager.showMenu();
    }

    private onClickLogLastShot(): void {

        AudioManager.playSound("click_btn");
        
        GameManager.logLastShot();
    }

    private onClickReset(): void {

        AudioManager.playSound("click_btn");
        
        GameManager.resetGame();
    }

    private onClickForceWin(): void {

        AudioManager.playSound("click_btn");

        const boardManager = BoardScene.currentInstance.boardManager;
        boardManager.onGameOver(GameVars.playerData.id);
    }

    private onClickForceLose(): void {

        AudioManager.playSound("click_btn");

        const boardManager = BoardScene.currentInstance.boardManager;
        boardManager.onGameOver(GameVars.adversaryData.id);
    }
}
